import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import type { BrowserHistory, Location } from '@remix-run/router/history';
import { TYPES } from './private';

export type IHistoryTransitionType = 'POP' | 'PUSH' | 'REPLACE';
export interface IHistoryEvent {
    action: IHistoryTransitionType;
    pathname: string;
    search: string;
    hash: string;
}

export interface IHistoryAction {
    go: (count: number) => void;
    goForward: () => void;
    goBack: () => void;
    push: (path: string) => void;
    replace: (path: string) => void;
}

export interface IHistoryTracking {
    length: () => number;
    history: () => Readonly<Readonly<Location>[]>;
    lastEvent: () => Readonly<IHistoryEvent> | undefined;
    previousLocation: () => Location | undefined;
    findFirstPathPrefix: (pathPrefix: string[]) => number;
    findPathPrefix: (pathPrefix: string) => number;
}

export interface IBrowserHistory {
    browserHistory: () => BrowserHistory | undefined;
}

export interface IHistory extends IBrowserHistory, IHistoryAction, IHistoryTracking {}

export function injectHistory(container: IContainer = injectOrBuildContainer()): IHistory {
    return container.get<IHistory>(TYPES.IHistory);
}

export function bindHistory(
    history: IHistory,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IHistory>(TYPES.IHistory, history);
}

export function unbindHistory(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IHistory);
}
